(function () {
  var root = document.querySelector('[data-pz-root]');
  if (!root) return;

  function wrapEvery15(text) {
    var words = text.split(' ');
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      if (current === '') {
        current = word;
      } else if (lines.length >= 2) {
        current += ' ' + word;
      } else if ((current + ' ' + word).length <= 15) {
        current += ' ' + word;
      } else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    return lines.join('\n');
  }


  var trigger = document.querySelector('[data-pz-trigger]');
  var overlay = document.querySelector('[data-pz-overlay]');
  var closeBtn = root.querySelector('[data-pz-close]');

  document.body.appendChild(overlay);
  document.body.appendChild(root);

  var lockedScrollY = 0;

  function openDrawer() {
    lockedScrollY = window.scrollY;
    root.style.visibility = 'visible';
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTimeout(function () {
      root.style.visibility = 'hidden';
    }, 250);
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var state = {
    mainVariantId: root.dataset.mainVariantId,
    basePrice: parseFloat(root.dataset.basePrice),
    priority: false,
    review: true,
    note: false
  };

  var addons = {
    bothsides: { id: root.dataset.bothsidesVariantId, price: parseFloat(root.dataset.bothsidesPrice) },
    priority: { id: root.dataset.priorityVariantId, price: parseFloat(root.dataset.priorityPrice) },
    review: { id: root.dataset.reviewVariantId, price: parseFloat(root.dataset.reviewPrice) },
    note: { id: root.dataset.noteVariantId, price: parseFloat(root.dataset.notePrice) }
  };

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  function selectPill(group, btn) {
    group.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active');
  }

  var bracelets = {};

  [1, 2].forEach(function (i) {
    var b = {
      color: 'Ασημένιο',
      size: 'Ανδρικό (20 εκατ.)',
      side: 'Εξωτερική (φανερή)',
      sidePrice: 0,
      font: 'Classic'
    };
    bracelets[i] = b;

    var engraveOuterGroup = root.querySelector('[data-pz-engrave-outer="' + i + '"]');
    var engraveInnerGroup = root.querySelector('[data-pz-engrave-inner="' + i + '"]');
    var engraveOuterInput = root.querySelector('[data-pz-field="engrave-outer-' + i + '"]');
    var engraveInnerInput = root.querySelector('[data-pz-field="engrave-inner-' + i + '"]');
    var previewWrapOuter = root.querySelector('[data-pz-preview-wrap="outer-' + i + '"]');
    var previewWrapInner = root.querySelector('[data-pz-preview-wrap="inner-' + i + '"]');
    var previewTextOuter = root.querySelector('[data-pz-preview="outer-' + i + '"]');
    var previewTextInner = root.querySelector('[data-pz-preview="inner-' + i + '"]');

    b.engraveOuterGroup = engraveOuterGroup;
    b.engraveInnerGroup = engraveInnerGroup;
    b.engraveOuterInput = engraveOuterInput;
    b.engraveInnerInput = engraveInnerInput;

    function updatePreview(which) {
      if (which === 'outer' || !which) {
        var textOuter = engraveOuterInput.value.trim();
        previewTextOuter.textContent = wrapEvery15(textOuter);
        previewWrapOuter.hidden = engraveOuterGroup.hidden || textOuter.length === 0;
      }
      if (which === 'inner' || !which) {
        var textInner = engraveInnerInput.value.trim();
        previewTextInner.textContent = wrapEvery15(textInner);
        previewWrapInner.hidden = engraveInnerGroup.hidden || textInner.length === 0;
      }
    }

    function applySide(value) {
      if (value === 'Εξωτερική (φανερή)') {
        engraveOuterGroup.hidden = false;
        engraveInnerGroup.hidden = true;
      } else if (value === 'Εσωτερική (κρυφή)') {
        engraveOuterGroup.hidden = true;
        engraveInnerGroup.hidden = false;
      } else {
        engraveOuterGroup.hidden = false;
        engraveInnerGroup.hidden = false;
      }
      updatePreview();
    }

    ['color-' + i, 'size-' + i, 'side-' + i, 'font-' + i].forEach(function (kind) {
      var group = root.querySelector('[data-pz-pills="' + kind + '"]');
      if (!group) return;
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pz__pill');
        if (!btn) return;
        selectPill(group, btn);
        var value = btn.dataset.value;

        if (kind === 'color-' + i) b.color = value;
        if (kind === 'size-' + i) b.size = value;
        if (kind === 'side-' + i) {
          b.side = value;
          b.sidePrice = parseFloat(btn.dataset.price || '0');
          applySide(value);
        }
        if (kind === 'font-' + i) {
          b.font = value;
          previewTextOuter.style.fontFamily = btn.style.fontFamily;
          previewTextInner.style.fontFamily = btn.style.fontFamily;
        }

        updateTotal();
      });
    });

    engraveOuterInput.addEventListener('input', function () {
      root.querySelector('[data-pz-charcount="outer-' + i + '"]').textContent = engraveOuterInput.value.length + '/45';
      updatePreview('outer');
    });

    engraveInnerInput.addEventListener('input', function () {
      root.querySelector('[data-pz-charcount="inner-' + i + '"]').textContent = engraveInnerInput.value.length + '/45';
      updatePreview('inner');
    });
  });

  var priorityToggle = root.querySelector('[data-pz-toggle="priority"]');
  priorityToggle.addEventListener('change', function () {
    state.priority = priorityToggle.checked;
    updateTotal();
  });

  var reviewToggle = root.querySelector('[data-pz-toggle="review"]');
  reviewToggle.addEventListener('change', function () {
    state.review = reviewToggle.checked;
    updateTotal();
  });

  var noteToggle = root.querySelector('[data-pz-toggle="note"]');
  noteToggle.addEventListener('change', function () {
    state.note = noteToggle.checked;
    updateTotal();
  });

  function updateTotal() {
    var total = state.basePrice;
    total += bracelets[1].sidePrice + bracelets[2].sidePrice;
    if (state.priority) total += addons.priority.price;
    if (state.review) total += addons.review.price;
    if (state.note) total += addons.note.price;
    root.querySelector('[data-pz-total]').textContent = formatMoney(total);
  }

  var errorEl = root.querySelector('[data-pz-error]');
  var submitBtn = root.querySelector('[data-pz-submit]');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  submitBtn.addEventListener('click', function () {
    errorEl.hidden = true;

    for (var idx = 1; idx <= 2; idx++) {
      var b = bracelets[idx];
      var outerVal = b.engraveOuterInput.value.trim();
      var innerVal = b.engraveInnerInput.value.trim();
      if (!b.engraveOuterGroup.hidden && !outerVal) {
        showError('Συμπλήρωσε το κείμενο χάραξης για το Βραχιόλι ' + idx + ' (εξωτερική πλευρά).');
        b.engraveOuterInput.focus();
        return;
      }
      if (!b.engraveInnerGroup.hidden && !innerVal) {
        showError('Συμπλήρωσε το κείμενο χάραξης για το Βραχιόλι ' + idx + ' (εσωτερική πλευρά).');
        b.engraveInnerInput.focus();
        return;
      }
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Προσθήκη...';

    var properties = {
      'Παρατηρήσεις - Σχόλια': root.querySelector('[data-pz-field="notes"]').value.trim()
    };

    var bothsidesCount = 0;

    [1, 2].forEach(function (idx) {
      var b = bracelets[idx];
      var prefix = 'Βραχιόλι ' + idx + ' - ';
      properties[prefix + 'Χρώμα'] = b.color;
      properties[prefix + 'Μέγεθος'] = b.size;
      properties[prefix + 'Πλευρά χάραξης'] = b.side;
      if (!b.engraveOuterGroup.hidden) properties[prefix + 'Γράψε τι θες να χαράξεις (Εξωτερική)'] = b.engraveOuterInput.value.trim();
      if (!b.engraveInnerGroup.hidden) properties[prefix + 'Γράψε τι θες να χαράξεις (Εσωτερική)'] = b.engraveInnerInput.value.trim();
      properties[prefix + 'Επιλογή Γραμματοσειράς'] = b.font;
      if (b.sidePrice > 0) bothsidesCount++;
    });

    var items = [];
    items.push({
      id: state.mainVariantId,
      quantity: 1,
      properties: properties
    });

    for (var k = 0; k < bothsidesCount; k++) {
      items.push({ id: addons.bothsides.id, quantity: 1 });
    }
    if (state.priority) items.push({ id: addons.priority.id, quantity: 1 });
    if (state.review) items.push({ id: addons.review.id, quantity: 1 });
    if (state.note) items.push({ id: addons.note.id, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showError('Κάτι πήγε στραβά. Δοκίμασε ξανά.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      });
  });

  updateTotal();
})();
